module.exports = "<ul class=ipt_elmList> <% _.each(airports, function(airport){ %> <li class=\"ipt_elmList_item <%= +airport.count !== 0 ? 'forcia-state-count' : 'forcia-css-disabled' %>\" data-state='{\"depAirport\": \"<%= airport.code %>\", \"subLayer\": \"\"}'><a href=# class=\"inr <%= airport.isSelected ? 'selected' : '' %>\"><%= airport.name %> [<%= airport.count %>件]</a> </li> <% }); %> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./web/WEB-INF/js/client/search/templates/departure.template.html
// module id = 64
// module chunks = 2